import { useApiClient } from 'bff/ApiClientProvider';
import { queryOptions, useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  ReportingGetTransactionSummaryDownloadRequest,
  ReportingGetTransactionSummaryReportRequest,
  ResponseError
} from 'bff/client';

export const getTransactionSummaryReport = (
  request: ReportingGetTransactionSummaryReportRequest
) => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['transactionSummary'],
    queryFn: async () => reportingApi.reportingGetTransactionSummaryReport(request),
    select: (response) => response.data?.transactions,
    staleTime: 0
  });
};

export const useGetTransactionSummaryDownload = (
  request: ReportingGetTransactionSummaryDownloadRequest,
  options?: UseMutationOptions<Blob, ResponseError>
) => {
  const { reportingApi } = useApiClient();
  const mutationOptions: typeof options = {
    ...options,
    mutationKey: ['getTransactionSummaryDownload'],
    mutationFn: async () => {
      const timeout = 15000;

      return await Promise.race([
        reportingApi.reportingGetTransactionSummaryDownload(request),
        new Promise<Blob>((_, reject) =>
          setTimeout(() => reject(new Error('Timeout after 15 secs')), timeout)
        )
      ]);
    }
  };
  return useMutation(mutationOptions);
};
